import { render, staticRenderFns } from "./CustomersFormInstitution.vue?vue&type=template&id=6d238dca&"
import script from "./CustomersFormInstitution.vue?vue&type=script&lang=js&"
export * from "./CustomersFormInstitution.vue?vue&type=script&lang=js&"
import style0 from "./CustomersFormInstitution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports